import classNames from 'classnames';
import map from 'lodash/map';
import React, { memo } from 'react';

import { useTableFilters } from '@/components/TableFilters/contexts/TableFiltersContext';

import FilterItem from './FilterItem';

const FilterList = (props) => {
  const { activeFilters } = useTableFilters();
  
  return <div className={classNames('w-full flex flex-col lg:flex-row lg:flex-wrap justify-end')}>
    {map(activeFilters, filter => <FilterItem key={filter?.name} filter={filter} {...props}/>)}
  </div>;
};

export default memo(FilterList);
